import type ApplicationInstance from "@ember/application/instance";
import AbdominalAreaFormComponent from "parog-web/components/abdominal-area/edition-form";
import AdverseEventEditionForm from "parog-web/components/adverse-events/edition-form";

import BioExamMonitoringEditionForm from "parog-web/components/bio-exam-monitoring/edition-form";
import BioExamResultsEditionFormComponent from "parog-web/components/bio-exam-results/edition-form";
import BioExamResultsNewEditionFormComponent from "parog-web/components/bio-exam-results/new-edition-form";
import BioExamResultsSummaryComponent from "parog-web/components/bio-exam-results/summary";
import CapillarityBloodGlucoseEditionFormComponent from "parog-web/components/capillarity-blood-glucose/edition-form";
import NewCareGiverFormComponent from "parog-web/components/care-giver/new";
import ChatContentComponent from "parog-web/components/chat/content";
import CompoundSurveyEditionComponent from "parog-web/components/compound-survey/edition";
import CompoundSurveyHistoryTableComponent from "parog-web/components/compound-survey/history-table";
import ConstantMonitoringEditionComponent from "parog-web/components/constant-monitoring/edition";
import ConsultationFrequencyEditionForm from "parog-web/components/consultation-frequency/edition-form";
import ConsultationFrequencyPhysicalEditionForm from "parog-web/components/consultation-frequency/physical-edition-form";
import ConsultationFrequencyPsychiatricEditionForm from "parog-web/components/consultation-frequency/psychiatric-edition-form";
import ConsultationEditionFormComponent from "parog-web/components/consultation/edition-form";
import ConsultationReportFormComponent from "parog-web/components/consultation/report-form";
import CrisisPlanFormComponent from "parog-web/components/crisis-plan/edition-form";

import DiabetowiseDischargeEditionFormComponent from "parog-web/components/diabetowise-discharge/edition-form";
import DiabguideEditionFormComponent from "parog-web/components/diabguide/edition-form";
import DisenrollmentForm from "parog-web/components/disenrollment/form";
import DisorderHistoryEditionFormComponent from "parog-web/components/disorder-history/edition-form";
import DocumentEditionFormComponent from "parog-web/components/document/edition-form";
import DpSessionEditionFormComponent from "parog-web/components/dp-cycle/edition-form";
import FeelingEvasFormComponent from "parog-web/components/feeling-evas/form";
import FileUploadedEditionFormComponent from "parog-web/components/file-uploaded/edition-form";
import HemodialysisSessionEditionFormComponent from "parog-web/components/hemodialysis-session/edition-form";
import HlaConsultForm from "parog-web/components/hla/consult-form";
import LifestylCoachingEditionComponent from "parog-web/components/lifestyle/coaching-edition-form";
import LifestyleEditionComponent from "parog-web/components/lifestyle/edition";
import GoalsEditionComponent from "parog-web/components/lifestyle/goals-edition-form";
import JobsEditionComponent from "parog-web/components/lifestyle/jobs-edition-form";
import MammographyEditionFormComponent from "parog-web/components/mammography/edition-form";
import HeightEditionFormComponent from "parog-web/components/measurements/height-edition-form";
import MeasurementsResults from "parog-web/components/measurements/results";
import WeightEditionFormComponent from "parog-web/components/measurements/weight-edition-form";
import MedicalEventEditionFormComponent from "parog-web/components/medical-event/edition-form";
import MedicalHistoryEditionFormComponent from "parog-web/components/medical-history/edition-form";
import MedicinesReconciliationFormComponent from "parog-web/components/medicines-reconciliation/edition-form";
import MiciCrohnSurveyConsultForm from "parog-web/components/mici/crohn-survey-consult-form";
import MiciCrohnSurveyEditionForm from "parog-web/components/mici/crohn-survey-edition-form";
import MiciCrohnSurveySummary from "parog-web/components/mici/crohn-survey-summary";
import MiciIbdDiskSurveyConsultForm from "parog-web/components/mici/ibd-disk-survey-consult-form";
import MiciIbdDiskSurveyConsultFormDetails from "parog-web/components/mici/ibd-disk-survey-consult-form-details";
import MiciIbdDiskSurveyEditionForm from "parog-web/components/mici/ibd-disk-survey-edition-form";
import MiciIbdDiskSurveySummary from "parog-web/components/mici/ibd-disk-survey-summary";
import MiciRchSurveyConsultForm from "parog-web/components/mici/rch-survey-consult-form";
import MiciRchSurveyEditionForm from "parog-web/components/mici/rch-survey-edition-form";
import MiciRchSurveySummaryComponent from "parog-web/components/mici/rch-survey-summary";
import ReportEditionFormComponent from "parog-web/components/online-consultation/report-edition-form";
import OxygeneSaturationEditionFormComponent from "parog-web/components/oxygene-saturation/edition-form";
import PersonalBackgroundFormComponent from "parog-web/components/personal-background/form";
import PersonalNotesEditionFormComponent from "parog-web/components/personal-notes/edition-form";
import AskForPrescription from "parog-web/components/prescription/ask-for-prescription";
import BioExamPrescriptionEditionFormComponent from "parog-web/components/prescription/bio-exam-edition-form";
import MedicalImagingEditionFormComponent from "parog-web/components/prescription/medical-imaging-edition-form";
import PrescriptionMedicationEditionForm from "parog-web/components/prescription/medication-edition-form";
import ParamedicalCareEditionFormComponent from "parog-web/components/prescription/paramedical-care-edition-form";
import MrcReplacementEditionFormComponent from "parog-web/components/replacement/edition-form";
import RespiratoryRateEditionFormComponent from "parog-web/components/respiratory-rate/edition-form";
import BdiIiEditionFormComponent from "parog-web/components/scale-surveys/bdi-ii-edition-form";
import FastEditionFormComponent from "parog-web/components/scale-surveys/fast-edition-form";
import ScaleSurveysHistory from "parog-web/components/scale-surveys/history";
import PhqNineEditionFormComponent from "parog-web/components/scale-surveys/phq-nine-edition-form";
import QidsEditionFormComponent from "parog-web/components/scale-surveys/qids-edition-form";
import YMRSEditionComponent from "parog-web/components/scale-surveys/ymrs-edition-form";
import StoolsNumberEditionFormComponent from "parog-web/components/stools-number/edition-form";
import TaskPlanificationComponent from "parog-web/components/task/edition-form";
import TemperatureEditionFormComponent from "parog-web/components/temperature/edition-form";
import ThymicEpisodeForm from "parog-web/components/thymic-episode/edition-form";
import TransmissionEditionComponent from "parog-web/components/transmission/edition";
import TreatmentHistoryEditionFormComponent from "parog-web/components/treatment-history/edition-form";
import VemsEditionFormComponent from "parog-web/components/vems/edition-form";

const ForcComponents = {
  "abdominal-area/edition-form": AbdominalAreaFormComponent,
  "adverse-events/edition-form": AdverseEventEditionForm,

  "bio-exam-monitoring/edition-form": BioExamMonitoringEditionForm,
  "bio-exam-results/edition-form": BioExamResultsEditionFormComponent,
  "bio-exam-results/new-edition-form": BioExamResultsNewEditionFormComponent,
  "bio-exam-results/summary": BioExamResultsSummaryComponent,
  "capillarity-blood-glucose/edition-form":
    CapillarityBloodGlucoseEditionFormComponent,
  "care-giver/new": NewCareGiverFormComponent,
  "chat/content": ChatContentComponent,
  "compound-survey/edition": CompoundSurveyEditionComponent,
  "compound-survey/history-table": CompoundSurveyHistoryTableComponent,
  "constant-monitoring/edition": ConstantMonitoringEditionComponent,
  "consultation-frequency/edition-form": ConsultationFrequencyEditionForm,
  "consultation-frequency/psychiatric-edition-form":
    ConsultationFrequencyPsychiatricEditionForm,
  "consultation-frequency/physical-edition-form":
    ConsultationFrequencyPhysicalEditionForm,
  "consultation/edition-form": ConsultationEditionFormComponent,
  "consultation/report-form": ConsultationReportFormComponent,
  "crisis-plan/edition-form": CrisisPlanFormComponent,
  "diabetowise-discharge/edition-form":
    DiabetowiseDischargeEditionFormComponent,
  "diabguide/edition-form": DiabguideEditionFormComponent,
  "disenrollment/form": DisenrollmentForm,
  "disorder-history/edition-form": DisorderHistoryEditionFormComponent,
  "dp-cycle/edition-form": DpSessionEditionFormComponent,
  "document/edition-form": DocumentEditionFormComponent,
  "feeling-evas/form": FeelingEvasFormComponent,
  "file-uploaded/edition-form": FileUploadedEditionFormComponent,
  "hemodialysis-session/edition-form": HemodialysisSessionEditionFormComponent,
  "hla/consult-form": HlaConsultForm,
  "lifestyle/coaching-edition-form": LifestylCoachingEditionComponent,
  "lifestyle/edition": LifestyleEditionComponent,
  "lifestyle/goals-edition-form": GoalsEditionComponent,
  "lifestyle/jobs-edition-form": JobsEditionComponent,
  "mammography/edition-form": MammographyEditionFormComponent,
  "mammography-and-mri/edition-form": MammographyEditionFormComponent,
  "measurements/height-edition-form": HeightEditionFormComponent,
  "measurements/results": MeasurementsResults,
  "measurements/weight-edition-form": WeightEditionFormComponent,
  "medical-event/edition-form": MedicalEventEditionFormComponent,
  "medical-history/edition-form": MedicalHistoryEditionFormComponent,
  "medicines-reconciliation/edition-form": MedicinesReconciliationFormComponent,
  "mici/crohn-survey-consult-form": MiciCrohnSurveyConsultForm,
  "mici/crohn-survey-edition-form": MiciCrohnSurveyEditionForm,
  "mici/crohn-survey-summary": MiciCrohnSurveySummary,
  "mici/ibd-disk-survey-consult-form-details":
    MiciIbdDiskSurveyConsultFormDetails,
  "mici/ibd-disk-survey-consult-form": MiciIbdDiskSurveyConsultForm,
  "mici/ibd-disk-survey-edition-form": MiciIbdDiskSurveyEditionForm,
  "mici/ibd-disk-survey-summary": MiciIbdDiskSurveySummary,
  "mici/rch-survey-consult-form": MiciRchSurveyConsultForm,
  "mici/rch-survey-edition-form": MiciRchSurveyEditionForm,
  "mici/rch-survey-summary": MiciRchSurveySummaryComponent,
  "online-consultation/report-edition-form": ReportEditionFormComponent,
  "oxygene-saturation/edition-form": OxygeneSaturationEditionFormComponent,
  "personal-background/form": PersonalBackgroundFormComponent,
  "personal-notes/edition-form": PersonalNotesEditionFormComponent,
  "prescription/ask-for-prescription": AskForPrescription,
  "prescription/bio-exam-edition-form": BioExamPrescriptionEditionFormComponent,
  "prescription/medical-imaging-edition-form":
    MedicalImagingEditionFormComponent,
  "prescription/medication-edition-form": PrescriptionMedicationEditionForm,
  "prescription/paramedical-care-edition-form":
    ParamedicalCareEditionFormComponent,
  "replacement/edition-form": MrcReplacementEditionFormComponent,
  "respiratory-rate/edition-form": RespiratoryRateEditionFormComponent,
  "scale-surveys/bdi-ii-edition-form": BdiIiEditionFormComponent,
  "scale-surveys/fast-edition-form": FastEditionFormComponent,
  "scale-surveys/phq-nine-edition-form": PhqNineEditionFormComponent,
  "scale-surveys/qids-edition-form": QidsEditionFormComponent,
  "scale-surveys/ymrs-edition-form": YMRSEditionComponent,
  "scale-surveys/history": ScaleSurveysHistory,
  "stools-number/edition-form": StoolsNumberEditionFormComponent,
  "task/edition-form": TaskPlanificationComponent,
  "temperature/edition-form": TemperatureEditionFormComponent,
  "thymic-episode/edition-form": ThymicEpisodeForm,
  "transmission/edition": TransmissionEditionComponent,
  "treatment-history/edition-form": TreatmentHistoryEditionFormComponent,
  "vems/edition-form": VemsEditionFormComponent
};

type ParogWebApplicationInstance = ApplicationInstance & {
  forcComponents: typeof ForcComponents;
};

export function initialize(owner: ParogWebApplicationInstance): void {
  owner.forcComponents = ForcComponents;
}

export default {
  initialize
};
